"use strict";
/* eslint-disable prefer-object-spread */
const en = require('./en');
module.exports = Object.assign({}, en, {
    '@lemonone/intl/text:estimation': 'duración estimada',
    '@lemonone/intl/text:duration_hours': '{hours, plural, =0 {} one {{hours} hora} other {{hours} horas}} {minutes, plural, =0 {} one {{minutes} minuto} other {{minutes} minutos}}',
    '@lemonone/intl/text:estimatedDuration': 'aprox. {hours, plural, =0 {} one {{hours} hora} other {{hours} horas}} {minutes, plural, =0 {} one {{minutes} minuto} other {{minutes} minutos}}',
    '@lemonone/intl/text:date': 'Fecha',
    '@lemonone/intl/text:address': 'Dirección',
    '@lemonone/intl/text:location': 'Locación',
    '@lemonone/intl/text:duration': 'Duración',
    // TODO: check these translations with natives
    '@lemonone/intl/text:product': 'Producto',
    '@lemonone/intl/text:id': 'ID',
    '@lemonone/intl/text:orderId': 'Solicitar ID',
    '@lemonone/intl/text:externalReference': 'Su ID de pedido interno',
    // TODO end
    '@lemonone/intl/text:required_datetime': 'Seleccione una fecha y hora',
    '@lemonone/intl/text:addressSyntax': 'Sintaxis de direcciones',
    '@lemonone/intl/text:streetName': 'Nombre de la calle',
    '@lemonone/intl/text:houseNumber': 'Número de casa',
    '@lemonone/intl/text:zipCode': 'Código postal',
    '@lemonone/intl/text:city': 'Ciudad',
    '@lemonone/intl/text:country': 'País',
    '@lemonone/intl/text:termsAndConditions': 'Términos y condiciones',
    '@lemonone/intl/text:termsAndConditionsUrl': 'https://www.lemonone.com/en/terms-conditions',
    '@lemonone/intl/text:privacyPolicy': 'Política de privacidad',
    '@lemonone/intl/text:privacyPolicyUrl': 'https://www.lemonone.com/en/privacy-policy',
    '@lemonone/intl/text:externalId': 'identificación de referencia',
    '@lemonone/intl/text:photoshootId': 'ID de sesión de fotos',
    '@lemonone/intl/text:feedback': 'Realimentación',
    '@lemonone/intl/text:notes': 'Notas',
    '@lemonone/intl/text:price': 'Precio',
    '@lemonone/intl/text:email': 'Email'
});
//# sourceMappingURL=es.js.map